// React
import React from "react";
// Redux
import * as redux from "redux";
import { connect } from "react-redux";
// Domain
import * as Actions from "office/reports/stats/actions";
import * as Selector from "office/reports/stats/selector";
import { ListingTypes } from "office/reports/stats/StatsReport";
import List from "common/ui/containers/list/List";
import DataBar from "common/ui/components/dataBar/DataBar";
import DataBarGroup from "common/ui/components/dataBar/DataBarGroup";
import DataBarItem from "common/ui/components/dataBar/DataBarItem";
import StatsCard from "common/ui/containers/cards/StatsCard";
import ListingViews from "office/reports/stats/components/graphCards/listing/ListingViews";
import ListingLeads from "office/reports/stats/components/graphCards/listing/ListingLeads";
import ListingAverageViews from "office/reports/stats/components/graphCards/listingPerformance/ListingAverageViews";
import ListingAverageLeads from "office/reports/stats/components/graphCards/listingPerformance/ListingAverageLeads";
import DateRangeWarning from "common/ui/components/dateRangeWarning/DateRangeWarning";
const mapStateToProps = (state, props) => ({
    report: Selector.reportSelector(state)
});
const mapDispatchToProps = (dispatch) => ({
    actions: redux.bindActionCreators(Actions, dispatch)
});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
class SalesPage extends React.Component {
    render() {
        const { report } = this.props;
        const reportData = report.reportData;
        const summaryData = reportData.data.summaryData;
        return (React.createElement(List, null,
            React.createElement(DateRangeWarning, { fromDate: report.reportData.fromDate, toDate: report.reportData.toDate }),
            React.createElement(StatsCard, null,
                React.createElement(DataBar, { label: "Key Metrics" },
                    React.createElement(DataBarItem, { description: "Total Sale Views", value: summaryData.viewsTotals.numForListings.sale, toolTip: "Total unique Rental listings in the given date range" }),
                    React.createElement(DataBarItem, { description: "Total Sale Leads", value: summaryData.leadsTotals.numForListings.sale, toolTip: "Total unique Sale listings in the given date range" }),
                    React.createElement(DataBarGroup, { flex: 1 },
                        React.createElement(DataBarItem, { description: "Total Sale Listings", value: summaryData.officeTotals.numListings.sale, toolTip: "Total unique listings in the given date range" })))),
            React.createElement(ListingLeads, { leadsStats: reportData.data.salesStatsGraphs, listingType: ListingTypes.Sales, fromDate: report.reportData.fromDate, toDate: report.reportData.toDate }),
            React.createElement(ListingViews, { viewsStats: reportData.data.salesStatsGraphs, listingType: ListingTypes.Sales, fromDate: report.reportData.fromDate, toDate: report.reportData.toDate }),
            React.createElement(List, null,
                React.createElement(ListingAverageViews, { charts: reportData.data.salesPerfGraphs, listingType: ListingTypes.Sales, fromDate: report.reportData.fromDate, toDate: report.reportData.toDate }),
                React.createElement(ListingAverageLeads, { charts: reportData.data.salesPerfGraphs, listingType: ListingTypes.Sales, fromDate: reportData.fromDate, toDate: reportData.toDate }))));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(SalesPage);
